import { Component, Host, Event, EventEmitter, getAssetPath, h, Watch, Prop } from '@stencil/core';
import globalDefaults from '../../defaults';
import defaults from './defaults';
import content from '../../content';

@Component({
  tag: 'src-learn-more',
  shadow: true,
  styleUrl: 'src-learn-more.scss',
  assetsDirs: [ 'assets' ],
})
export class SrcLearnMore {

  /**
   * Boolean value used to determine the visibility of the close button
   */
  @Prop() displayCloseButton: boolean = defaults.displayCloseButton;

  /**
   * Boolean value used to determine the visibility of the OK button
   */
  @Prop() displayOkButton: boolean = defaults.displayOkButton;

  /**
   * Boolean value to enable dark mode
   */
  @Prop() dark: boolean = false;

  /**
   * DPA locale used to set the language
   */
  @Prop() locale: string = globalDefaults.locale;

  /**
   * Comma-separated list of supported card brands
   */
  @Prop() cardBrands: string = globalDefaults.cardBrand;

  /**
   * Boolean value to determine the visibility of the Click to Pay branding
   */
  private displayHeader: boolean = globalDefaults.displayHeader;

  @Watch('locale')
  localeWatcher () {
    content.setLocale(this.locale);
  }

  componentWillLoad() {
    content.setLocale(this.locale);
  }

  /**
   * Fires when the user clicks the close button
   */
  @Event({
    eventName: 'close'
  }) closeClickEvent: EventEmitter<null>;

  private handleCloseClick(e) {
    this.closeClickEvent.emit(e);
  }

  /**
   * Fires when the user clicks the OK button
   */
  @Event({
    eventName: 'ok'
  }) okClickEvent: EventEmitter<null>;

  private handleOkClick(e) {
    this.okClickEvent.emit(e);
  }
  /**
  * @function getCloseIcon
  * @description handle the path of the close icon
  */
   private getCloseIcon() {
    return this.dark ? getAssetPath('./assets/icons/close-dark.svg') : getAssetPath('./assets/icons/close.svg');
   }

  constructor() {
    this.handleCloseClick = this.handleCloseClick.bind(this);
    this.handleOkClick = this.handleOkClick.bind(this);
  }

  render() {
    return (
      <Host>
        <div class="container">
          <div class="row margin-top-lg">
            <div class="col-3">
              <h1 class="margin-bottom-sm display-xl">
                {content.$t('learnMore.heading1')}<br />
                <span class="color-orange-high">{content.$t('learnMore.heading2')}</span>
              </h1>
            </div>
            <div class="col-1">
              {this.displayCloseButton &&
              <nav class="col row-align-right">
                <button aria-label="Close" type="button" class="btn--no-padding margin-bottom-none"
                  onClick={this.handleCloseClick}>
                    <i
                      class="icon-close icon-size-xs"
                      style={{ backgroundImage: 'url(' + this.getCloseIcon() + ')' }} />
                  </button>
              </nav>
              }
            </div>
          </div>
          <div class="row margin-bottom-sm">
            <div>
              <h2 class={`line-height margin-bottom-xs weight-light heading-md`}>
                { content.$t('learnMore.subheading')}
              </h2>
              <div class="margin-bottom-xs">
                <sal-header
                  card-brands={this.cardBrands}
                  display-header={this.displayHeader}
                  dark={this.dark}
                />
              </div>

              <div class="col align-left">
                <ul>
                  <li class="list__item--bullet list__item--extra-space">
                    <p
                    data-test="list-item-first"
                    class="weight-light">
                      {content.$t("learnMore.bullet1")}
                    </p>
                  </li>
                  <li class="list__item--bullet list__item--extra-space">
                    <p
                    data-test="list-item-second"
                    class="weight-light">
                      {content.$t("learnMore.bullet2")}
                    </p>
                  </li>
                  <li class="list__item--bullet list__item--extra-space">
                    <p
                    data-test="list-item-third"
                    class="weight-light">
                    {content.$t('learnMore.bullet3')}
                    </p>
                  </li>
                </ul>
              </div>
              {this.displayOkButton &&
                <sal-button
                  onClick={this.handleOkClick}>
                  {content.$t('learnMore.buttonLabel')}
                </sal-button>
              }
            </div>
          </div>
        </div>
      </Host>
    );
  }
}
